import { useParameterStore } from '@/frontend/store/ParameterStore';
import { I18n } from '@/i18n/I18n';
import { Parameter } from '@/backend/models/parameter';
import { OverlayTrigger, Popover } from 'react-bootstrap';
import { useShallow } from 'zustand/react/shallow';
import { ValidationRun } from './ValidationRun';

export function ViewValidationsButton(props: { parameter: Parameter, placement: 'left' | 'right' }) {
  const { parameter, placement } = props;

  const validations = useParameterStore(useShallow(state => state.getValidationForSubject(parameter.id)));

  return (
    <OverlayTrigger
      trigger="click"
      placement={placement}
      overlay={
        <Popover id="validations-popover">
          <Popover.Header as="h3">{I18n.get('validations')}</Popover.Header>
          <Popover.Body>
            <div className='d-flex flex-column gap-1'>
              {validations.map(validation => (
                <ValidationRun
                  key={validation.id}
                  validation={validation}
                />
              ))}
            </div>
          </Popover.Body>
        </Popover>
      }
      rootClose
    >
      <button
        type="button"
        className='btn btn-link btn-sm p-0 text-decoration-underline'
        style={{ fontSize: '0.75rem' }}
      >
        {`(${I18n.get('viewValidations')})`}
      </button>
    </OverlayTrigger>
  );
}
